"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubmitBackgroundCheckDto = instanceOfSubmitBackgroundCheckDto;
exports.SubmitBackgroundCheckDtoFromJSON = SubmitBackgroundCheckDtoFromJSON;
exports.SubmitBackgroundCheckDtoFromJSONTyped = SubmitBackgroundCheckDtoFromJSONTyped;
exports.SubmitBackgroundCheckDtoToJSON = SubmitBackgroundCheckDtoToJSON;
exports.SubmitBackgroundCheckDtoToJSONTyped = SubmitBackgroundCheckDtoToJSONTyped;
/**
 * Check if a given object implements the SubmitBackgroundCheckDto interface.
 */
function instanceOfSubmitBackgroundCheckDto(value) {
    return true;
}
function SubmitBackgroundCheckDtoFromJSON(json) {
    return SubmitBackgroundCheckDtoFromJSONTyped(json, false);
}
function SubmitBackgroundCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'backgroundCheckPackageId': json['backgroundCheckPackageId'] == null ? undefined : json['backgroundCheckPackageId'],
    };
}
function SubmitBackgroundCheckDtoToJSON(json) {
    return SubmitBackgroundCheckDtoToJSONTyped(json, false);
}
function SubmitBackgroundCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'backgroundCheckPackageId': value['backgroundCheckPackageId'],
    };
}
//# sourceMappingURL=SubmitBackgroundCheckDto.js.map